import { Component, Input, OnInit } from '@angular/core';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';
import { ResponsiveDesignService } from 'src/app/common/services/responsive-design/responsive-design.service';
import { ExternalSettings } from 'src/app/common/services/external-settings/external-settings.interface';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';
import { PAGroup } from 'src/app/common/services/permitted-activity/pa-menu-meta';


@Component({
    selector: 'app-sidebar-group',
    templateUrl: './me-sidebar-group.component.html',
    styleUrls: ['./me-sidebar-group.component.less'],
    standalone: false
})
export class MeSidebarGroupComponent implements OnInit {
  @Input() group!: PAGroup;
  externalSettings!: ExternalSettings;
  UIUtilityService: any = UIUtilityService;

  constructor(
    private srvES: ExternalSettingsService,
    private srvRpDesign: ResponsiveDesignService
  ) {}

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((externalSettings) => {
      this.externalSettings = externalSettings;
    });
  }

  dismissSidebarNav(): void {
    this.srvRpDesign.setSidebarNav(false);
  }
}